import React, {useRef, useEffect, useState, useCallback, useMemo} from "react";
import {
    Button,
    Dimmer, Dropdown,
    Form, Input, Label,
    Loader,
    Message,
    Modal,
} from "semantic-ui-react";
import {
    useActiveProjectSelector, useClientIdSelector,
    useProjectLoadingStageSelector,
    useUploadingNewProject,
} from "../../../../../../store/selectors/project.selectors";
import { Maybe } from "@martin_hotell/rex-tils";
import { FileApi } from "../../../../../../api/file.api";
import FirebaseUsage from "../../../../../../firebase/firebase.usage";
import { UploadProjectDataTable } from "./components/UploadProjectDataTable";
import { Omit } from "@martin_hotell/rex-tils";
import * as ProjectActions from "../../../../../../store/actions/project.actions";
import { useDispatch } from "react-redux";
import ProjectTransactions from "../../../../../../store/thunk/transactions/project.transactions";
import { useUserSelector } from "../../../../../../store/selectors/authorization.selectors";
import fetch from "node-fetch";
import {COLLECTIONS} from "../../../../../../firebase/constants";
import {ClientDocModel} from "../../../../../../models/responses/client.model";
import NewContractForm from "./components/NewContractForm";
import firebaseConfig from "../../../../../../config/firebase.config";

export interface ProjectsData {
  id: string;
  name: string;
  projectDataUrl: any;
  exist: boolean;
  errorMessage?: string;
  projectData: any;
  clientId: string;
}

interface InjectProps {
  open: boolean;
  onClose: () => void;
  title: string;
  multiFile: boolean;
  errorMessage?: string;
  isUpdate?: boolean;
  //handleInput: () => void;
  setErrorMessage?: (message: string) => void;
  setUploadStrategyModalOpen: (value: boolean) => void;
  setShowUploadModal: any;
}

type PropsType = InjectProps;

const LoaderSpinner: React.FC<{ text: string }> = ({ text }) => (
  <div className="loader-wrap">
    <Dimmer active inverted>
      <Loader inverted>{text}</Loader>
    </Dimmer>
  </div>
);

export const UploadProjectData: React.FC<PropsType> = (props) => {
  //const [dragInZone, setDragInZone] = useState(false);
  const loading = useUploadingNewProject();
  const [localStartLoading, setLocalStartLoading] = useState(false);
  const [openUploadFile, setOpenUploadFile] = useState(props.isUpdate);
  const [disabled, setDisabled] = useState(true);
  const [fileTransformationLoading, setFileTransformationLoading] =
    useState(false);
  const [projects, setProjects] = useState<ProjectsData[]>([]);
  const [localErrorMessage, setLocalErrorMessage] = useState("");
  const [renameOccured, setRenameOccured] = useState(false);
  const user = useUserSelector();
  const [isProjectUploadCanceling, setIsProjectUploadCanceling] =
    useState<boolean>(false);
  const dispatch = useDispatch();
  const projectLoadingStage = useProjectLoadingStageSelector();
  // const [isProjectUploaded, setIsProjectUploaded] = useState<boolean>(false);
  const isMountedRef = useRef(false);
  const inputHandler = useRef<HTMLInputElement | null>(null);
  const [confirmTerms, setConfirmTerms] = useState(false);
  const clientId = useClientIdSelector();
  const [formData, setFormData] = useState<any>({
    contractName: undefined,
    contractReference: undefined,
    contractType: undefined,
    contractValue: 0,
    clientId: clientId,
    sprintStartDay: undefined,
    sprintLockTime: undefined,
  });
  const [contractData, setContractData] = useState<any>({});
  const [contractValidated, setContractValidated] = useState(false);
  const [clients, setClients] = useState<any[]>([]);
  const [flowledgerUser, setFlowledgerUser] = useState(false);
  const activeProject = useActiveProjectSelector();

  useEffect(() => {
    if (props.open && !localStartLoading) {
      inputHandler.current?.click();
      var body = document.body;
      if (!body.classList.contains("completeModal")) {
        body.classList.add("hiddenModal");
      }
    }
  }, [props, localStartLoading, openUploadFile]);

  useEffect(() => {
    isMountedRef.current = true;
    if (loading && localStartLoading) {
      setLocalStartLoading(false);
    }
    return () => {
      isMountedRef.current = false;
    };
  }, [loading, localStartLoading]);

  useEffect(() => {
    isMountedRef.current = true;
    if (props.errorMessage) {
      setLocalStartLoading(false);
    }
    return () => {
      isMountedRef.current = false;
    };
  }, [props.errorMessage]);

  useEffect(() => {
    isMountedRef.current = true;
    setDisabled(!projects.length);
    if (!projects.length && props.setErrorMessage) {
      props.setErrorMessage("");
      setLocalErrorMessage("");
    }
    if (projects.some((project) => project.exist)) {
      setLocalErrorMessage(
        `This project(s) "${projects
          .filter((el) => el.exist)
          .map((el) => el.name)
          .join(",")}" is already in use, please rename!`
      );
    } else {
      setLocalErrorMessage("");
    }
    return () => {
      isMountedRef.current = false;
    };
  }, [projects, props]);

  useEffect(() => {
    isMountedRef.current = true;
    if (projectLoadingStage.projectLoaded) {
      setIsProjectUploadCanceling(false);
    }
    return () => {
      isMountedRef.current = false;
    };
  }, [projectLoadingStage]);

  const uploadProject = (event: React.MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();
      event.preventDefault();
      localStorage.removeItem("projectId");
      if (isMountedRef.current) {
        dispatch(
          ProjectActions.Actions.setProjectLoadingStage({
            ...projectLoadingStage,
            projectLoaded: false,
            projectStopped: false,
          })
        );
      }
      setLocalStartLoading(true);
      setOpenUploadFile(false);
      setTimeout(() => {
        projects.map(async (project) => {
            if (project.errorMessage) {
                return;
            }
            await FirebaseUsage.updateDoc(COLLECTIONS.PROJECT_UPLOADS, project.id, {
                status: 'pending'
            })
            if (!props.isUpdate && contractData) {
                await FirebaseUsage.setDocument(COLLECTIONS.CONTRACTS, contractData.contractId, contractData)
            }
            fetch(`${firebaseConfig.uploadApiUrl}/?uploadId=${project.id}&clientId=${props.isUpdate && activeProject ? activeProject.clientId : contractData.clientId}`)
                .catch(e => console.log(e))
            if (props.isUpdate) {
                dispatch(ProjectActions.Actions.setActiveProjectId(null));
                dispatch(ProjectActions.Actions.setActiveProject(null));
                dispatch(ProjectActions.Actions.setProjectLoadingStage({
                    ...projectLoadingStage,
                    projectLoaded: false,
                    projectStopped: false,
                }));
            }
            props.setUploadStrategyModalOpen(false);
            props.setShowUploadModal(project.id)
        });
      }, 100);
    }

  const checkOnProjectExits = useCallback(
    async (projectList: { name: string }[]) => {
      return FirebaseUsage.functions("checkIfProjectExist")(projectList).then(
        (data) => data.data
      );
    },
    []
  );

  const onDropHandler = async (files: Maybe<FileList>) => {
      //setDragInZone(false);
      var body = document.body;
      body.classList.remove("hiddenModal");
      body.classList.add("completeModal");

      if (!files) {
        return;
      }
      console.log(files);
      console.log(props);

      setFileTransformationLoading(true);
      let jsonData = await FileApi.transformXerToJson(
        props.multiFile ? files : files.item(0),
        props.isUpdate,
        props.isUpdate
          ? activeProject
            ? activeProject.projectId
            : null
          : null,
        user,
        contractValidated ?
            contractData.contractId :
            activeProject ?
                activeProject.contractId ?
                activeProject.contractId :
                null :
                null
      );

      const newProjectList: any[] = [];
      jsonData.forEach((data, i) => {
        newProjectList.push(
          data.errorMessage
            ? {
                errorMessage: data.errorMessage,
              }
            : {
                name: data[0],
                id: data[1],
              }
        );
      });

      const existingProjects: any = await checkOnProjectExits(
        newProjectList.map((e) => {
          return { name: e.name };
        })
      );
      setProjects(
        newProjectList.map((project) => ({
          ...project,
          exist: existingProjects.some((el) => el === project.name),
        }))
      );
      setFileTransformationLoading(false);

      const projectsWithEist = newProjectList.map((project) => ({
        ...project,
        exist: existingProjects.some((el) => el === project.name),
      }));

      if (projectsWithEist.some((project) => project.exist)) {
        //setDragInZone(true);
        return;
      }

      if (!confirmTerms) {
        return;
      }

      // // Upload
      // localStorage.removeItem("projectId");
      // if (isMountedRef.current) {
      //   dispatch(
      //     ProjectActions.Actions.setProjectLoadingStage({
      //       ...projectLoadingStage,
      //       projectLoaded: false,
      //       projectStopped: false,
      //     })
      //   );
      // }
      // setLocalStartLoading(true);
      // setTimeout(() => {
      //   props.uploadHandler(newProjectList, async () => {
      //     setLocalStartLoading(false);
      //     props.onClose();
      //     setLocalStartLoading(false);
      //     setProjects(
      //       newProjectList.map((project) => ({
      //         ...project,
      //         exist: existingProjects.some((el) => el === project.name),
      //       }))
      //     );
      //   });
      // }, 100);
    }

  const closeModal = useCallback(() => {
    props.onClose();
    setProjects([]);
    setConfirmTerms(false);
    setLocalStartLoading(false);
    var body = document.body;
    body.classList.add("hiddenModal");
    body.classList.remove("dimmable");
    body.classList.remove("dimmed");
  }, [props]);

  const cancelUpload = useCallback(async () => {
    if (localStartLoading) {
      setIsProjectUploadCanceling(true);
      if (isMountedRef.current) {
        dispatch(
          ProjectActions.Actions.setProjectLoadingStage({
            ...projectLoadingStage,
            projectStopped: true,
            projectNames: projects.map((el) => el.name),
          })
        );
      }
    } else {
      setProjects([]);
    }
    if (user && localStartLoading) {
      await ProjectTransactions.cancelProjectUploading(
        projects.map((el) => el.name),
        user
      );
      setIsProjectUploadCanceling(false);
    }
    closeModal();
  }, [
    closeModal,
    dispatch,
    projectLoadingStage,
    localStartLoading,
    projects,
    user,
  ]);

    useEffect(() => {
        if (user && user.userEmail.includes('flowledger.io')) {
            FirebaseUsage.getCollection(COLLECTIONS.CLIENTS)
                .then((snapshot) =>
                    setClients(snapshot.docs.map((doc) => ({
                        key: doc.id,
                        text: doc.data().domain,
                        value: doc.id,
                    }))))
            setFlowledgerUser(true)
        } else {
        }
    }, []);

    const formDataValidated = useMemo(() => {
        return !(
            !formData.contractName ||
            !formData.contractReference ||
            !formData.contractType ||
            !formData.clientId ||
            !formData.sprintStartDay ||
            !formData.sprintLockTime
        )
    }, [formData]);

    const createContract = async () => {
        if (formDataValidated) {
            const client = clients.find((client) => client.value === formData.clientId);
            const contractDoc = FirebaseUsage.getBlankDoc(COLLECTIONS.CONTRACTS);

            const contract = {
                contractId: contractDoc.id,
                contractName: formData.contractName,
                contractReference: formData.contractReference,
                formOfContract: formData.contractType,
                clientId: formData.clientId,
                clientDomain: client ? client.text : null,
                contractValue: formData.contractValue,
                dataSnapshotWeekdays: [formData.sprintStartDay],
                sprintLockTime: formData.sprintLockTime * 3600,
                leadUser: user!.userId,
                affiliatedUsers: {[user!.userId!]: 'Super-Actor'},
            }

            setContractData(contract);
            setContractValidated(true);
            setOpenUploadFile(true)
        }
    }

  return (
    <>
      {isProjectUploadCanceling && (
        <Dimmer active>
          <Loader indeterminate>Canceling project upload...</Loader>
        </Dimmer>
      )}

      {!localErrorMessage && openUploadFile && (
        <div style={{ opacity: "0" }}>
          <input
            type="file"
            name="file"
            id="file"
            className="inputfile"
            accept="*"
            ref={inputHandler}
            disabled={fileTransformationLoading}
            onChange={(evt) => onDropHandler(evt.target.files)}
          />
        </div>
      )}

      {
        <Modal
          open={props.open}
          closeIcon
          closeOnTriggerBlur={false}
          closeOnDimmerClick={false}
          onClose={!loading ? closeModal : undefined}
          style={{ animationDuration: "1s" }}
        >
          <Modal.Header>
            {localErrorMessage ? localErrorMessage : props.title}
          </Modal.Header>
          <Modal.Content image>
            <div className="flex-1">
              {props.errorMessage && fileTransformationLoading && (
                <Message negative>
                  <Message.Header>{props.errorMessage}</Message.Header>
                </Message>
              )}
              {projects
                .filter((project) => project.errorMessage)
                .map((project) => (
                  <Message key={project.id} negative>
                    <Message.Header>{project.name}:</Message.Header>
                    <p>{project.errorMessage}</p>
                  </Message>
                ))}
              <div className="relative flex-1">
                {localStartLoading ? (
                  <LoaderSpinner text="Creating pull system - this may take a few minutes" />
                ) : null}
                {fileTransformationLoading ? (
                  <LoaderSpinner text="Preparing to upload..." />
                ) : null}
                {loading ? <LoaderSpinner text="Uploading..." /> : null}
                  {props.isUpdate ?
                      <div style={{height: 50, position: "relative", textAlign: "center"}}>
                          Ready To Update
                      </div> :
                <NewContractForm
                  contractValidated={contractValidated}
                  formData={formData}
                  setFormData={setFormData}
                  clients={clients}
                  flowledgerUser={flowledgerUser}
                />}
              </div>
            </div>
          </Modal.Content>
          <Modal.Actions
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div
              className="terms"
              style={{
                pointerEvents: localStartLoading ? "none" : "unset",
                display: "flex",
                marginLeft: "10px",
              }}
            >
              <input
                type="checkbox"
                id="terms"
                disabled={contractValidated}
                checked={confirmTerms}
                onChange={() => setConfirmTerms(!confirmTerms)}
                style={{ cursor: "pointer", marginRight: "10px" }}
              />
              <label htmlFor="terms" style={{ cursor: "pointer" }}>
                I confirm that I have read and accept the &nbsp;
                <a
                  href="https://www.flowledger.io/customer-terms-of-service"
                  style={{ cursor: "pointer" }}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  Customer Terms of Service
                </a>
              </label>
            </div>
            <div className="buttons">
              <Button
                negative
                disabled={loading}
                onClick={cancelUpload}
                style={{ marginRight: "15px" }}
              >
                Cancel
              </Button>
                {!contractValidated && !props.isUpdate && <Button
                    onClick={createContract}
                    positive
                    disabled={!formDataValidated || !confirmTerms}
                    icon="plus"
                    labelPosition="right"
                    content="Create"
                />}
                {props.isUpdate || contractValidated ? <Button
                onClick={uploadProject}
                positive
                disabled={
                  disabled ||
                  loading ||
                  projects.some((project) => project.exist) ||
                  localStartLoading ||
                  fileTransformationLoading ||
                  !confirmTerms
                }
                icon="checkmark"
                labelPosition="right"
                content="Upload"
              /> : null}
            </div>
          </Modal.Actions>
        </Modal>
      }
    </>
  );
};
